export * from "./paid-landing.template";
export * from "./paid-jsm.template";
export * from "./paid-conf.template";
export { PaidLandingTemplate as default } from "./paid-landing.template";
